module.exports = __webpack_public_path__ + "img/facade.bb4c8eff.svg";